import axios from "axios";

const API_AUTH_LOGIN = "/auth/login";
const API_AUTH_RESET = "/auth/reset-password";
const API_AUTH_REGISTER = "/auth/register";
const API_AUTH_REGISTER_CHECK = "/auth/register/check";
const API_AUTH_PLAN_INFO = "/auth/plan-info";
const API_MEMBER_RENEW = "/member/renew";
const API_MEMBER_RESUME_PAY = "/member/resume-pay";
const API_MEMBER_INFO = "/member/info";
const API_MEMBER_PROFILE = "/member/profile";
const API_MEMBER_PROFILE_ICON = "/member/profile-icon";
const API_MEMBER_CURRENT_PLAN = "/member/current-plan";

export const api = axios.create({
  baseURL:
    process.env.REACT_APP_API_HOSTNAME ||
    "https://hkiff-membership-api-dev.cloud.udev.hk",
  headers: {
    "Content-Type": "application/json",
  },
  timeout: process.env.NODE_ENV === "development" ? null : 10000,
});

console.log(api.defaults);

const registerCheck = (contactNumber) => {
  return api.get(`${API_AUTH_REGISTER_CHECK}?contactNumber=${contactNumber}`);
};

const register = (language, data) => {
  return api.post(API_AUTH_REGISTER, data, {
    headers: {"Accept-Language": language}
  });
};

const renew = (token, data) => {
  return api.post(API_MEMBER_RENEW, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const resumePay = (token, data) => {
  return api.post(API_MEMBER_RESUME_PAY, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const login = (data) => {
  return api.post(API_AUTH_LOGIN, data);
};

const reset = (data) => {
  return api.post(API_AUTH_RESET, data);
};

const getPlanInfo = (language, token) => {
  return api.get(API_AUTH_PLAN_INFO, {
    headers: {
      "Accept-Language": language,
    ...(token && {Authorization: `Bearer ${token}`})
    },
  });
};

const getMemberInfo = (token) => {
  return api.get(API_MEMBER_INFO, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const getMemberProfile = (token) => {
  return api.get(API_MEMBER_PROFILE, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const updateMemberProfile = (token, data) => {
  return api.post(API_MEMBER_PROFILE, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const updateProfileIcon = (token, formData) => {
  return api.post(API_MEMBER_PROFILE_ICON, formData, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const getMemberCurrentPlan = (token) => {
  return api.get(API_MEMBER_CURRENT_PLAN, {
    headers: { Authorization: `Bearer ${token}`, "Accept-Language": "en" },
  });
};

const apiHelper = {
  login,
  reset,
  register,
  renew,
  resumePay,
  registerCheck,
  getPlanInfo,
  getMemberInfo,
  getMemberProfile,
  updateMemberProfile,
  updateProfileIcon,
  getMemberCurrentPlan,
};

export default apiHelper;
